import React from 'react';
import { capitalize, cn } from '@express-labs/raven-tools';
import {
  Account,
  AlertIcon,
  AlertIconBlack,
  AList,
  Amex,
  AnimatedCheckmark,
  ArrowBack,
  ArrowDown,
  ArrowLeft,
  ArrowUp,
  Bag,
  BBBSHorizontalLogo,
  BBBSVerticalLogo,
  BirthdayGift,
  Call,
  Chat,
  Check,
  CheckGreen,
  CircleCheckMark,
  Circle,
  CircleArrowsIcon,
  CellPhone,
  CloseIcon,
  Discover,
  DollarIcon,
  EarlyAccess,
  EarnRewards,
  Email,
  ErrorRed,
  ExpNextLogo,
  ExpressCreditCard,
  ExpressLogo,
  ExclusiveOffer,
  Facebook,
  FasterPointsIcon,
  FasterRewardsIcon,
  ExpressCreditCardLogo,
  ExpressInsiderLogo,
  ExpressInsiderLockIcon,
  ExpressInsiderLogoBlack,
  ExpressInsiderLogoSecondaryBlack,
  ExpressInsiderCreditCardLogo,
  ExpStyleEditorsLogoPrimaryBlack,
  EmailIcon,
  FreeShipping,
  FreeReturns,
  GiftCard,
  Google,
  GoogleColorG,
  GooglePlus,
  GreenDot,
  Grid1,
  Grid2,
  Grid3,
  Grid4,
  Grid5,
  HelpPhone,
  InsiderCard,
  Instagram,
  InfoToolTipIcon,
  LiveChat,
  LiveChat2,
  LockIcon,
  LoyaltyInsiderLogoBlack,
  LoyaltyInfluencerLogoBlack,
  LoyaltyAListLogoBlack,
  LoyaltyVIPLogoBlack,
  LoyaltyInsiderLogoWhite,
  LoyaltyInfluencerLogoWhite,
  LoyaltyAListLogoWhite,
  LoyaltyVIPLogoWhite,
  Mail,
  MasterCard,
  MeasuringTape,
  Minus,
  MyAccountLoginLogo,
  NextCard,
  NextSlash,
  CreditCard,
  NoticeIcon,
  OnlineOrder,
  Overview,
  PayPal,
  PayBill,
  PhoneIcon,
  PinPad,
  Pinterest,
  Pipe,
  PersonalInfoIcon,
  Plus,
  Present,
  ReceiptlessReturns,
  RedStripe,
  Rewards,
  RewardsEmptyWhite,
  RewardStarDark,
  RewardStarLight,
  SellerIcon,
  ShipToHome,
  ShippingTruck,
  SearchIcon,
  ShoppingBag,
  StyleEditorLogo,
  ToolTipIcon,
  Twitter,
  Visa,
  WarningYellow,
  X,
  YouTube,
} from './svg';
import s from './Icon.scss';

// Tricky name.  Please notice the "s" in IconsProps below.
export interface IconsProps extends IconV1Props {
  hasBackgroundCircle?: boolean;
  backgroundCircleClass?: string;
  backgroundCircleFill?: string;
}

export const svgs = {
  account: Account,
  alertIcon: AlertIcon,
  alertIconBlack: AlertIconBlack,
  aList: AList,
  amex: Amex,
  animatedCheckmark: AnimatedCheckmark,
  arrowBack: ArrowBack,
  arrowDown: ArrowDown,
  arrowLeft: ArrowLeft,
  arrowUp: ArrowUp,
  bag: Bag,
  bbbsHorizontalLogo: BBBSHorizontalLogo,
  bbbsVerticalLogo: BBBSVerticalLogo,
  birthdayGift: BirthdayGift,
  call: Call,
  chat: Chat,
  check: Check,
  checkGreen: CheckGreen,
  circleCheckMark: CircleCheckMark,
  circle: Circle,
  circleArrows: CircleArrowsIcon,
  closeIcon: CloseIcon,
  cellPhone: CellPhone,
  discover: Discover,
  dollarIcon: DollarIcon,
  earlyAccess: EarlyAccess,
  earnRewards: EarnRewards,
  email: Email,
  errorRed: ErrorRed,
  expNextLogo: ExpNextLogo,
  expressCreditCard: ExpressCreditCard,
  expressLogo: ExpressLogo,
  expressCreditCardLogo: ExpressCreditCardLogo,
  expressInsiderLockIcon: ExpressInsiderLockIcon,
  expressInsiderCreditCardLogo: ExpressInsiderCreditCardLogo,
  expressInsiderLogo: ExpressInsiderLogo,
  expressInsiderLogoBlack: ExpressInsiderLogoBlack,
  expressInsiderLogoSecondaryBlack: ExpressInsiderLogoSecondaryBlack,
  expStyleEditorsLogoPrimaryBlack: ExpStyleEditorsLogoPrimaryBlack,
  exclusiveOffer: ExclusiveOffer,
  emailIcon: EmailIcon,
  fasterPointsIcon: FasterPointsIcon,
  fasterRewardsIcon: FasterRewardsIcon,
  freeShipping: FreeShipping,
  freeReturns: FreeReturns,
  facebook: Facebook,
  giftCard: GiftCard,
  google: GooglePlus,
  googleColorG: GoogleColorG,
  googleOld: Google,
  greenDot: GreenDot,
  grid1: Grid1,
  grid2: Grid2,
  grid3: Grid3,
  grid4: Grid4,
  grid5: Grid5,
  helpPhone: HelpPhone,
  insiderCard: InsiderCard,
  instagram: Instagram,
  infoToolTipIcon: InfoToolTipIcon,
  liveChat: LiveChat,
  liveChat2: LiveChat2,
  lock: LockIcon,
  loyaltyInsiderLogoBlack: LoyaltyInsiderLogoBlack,
  loyaltyInfluencerLogoBlack: LoyaltyInfluencerLogoBlack,
  loyaltyAListLogoBlack: LoyaltyAListLogoBlack,
  loyaltyVIPLogoBlack: LoyaltyVIPLogoBlack,
  loyaltyInsiderLogoWhite: LoyaltyInsiderLogoWhite,
  loyaltyInfluencerLogoWhite: LoyaltyInfluencerLogoWhite,
  loyaltyAListLogoWhite: LoyaltyAListLogoWhite,
  loyaltyVIPLogoWhite: LoyaltyVIPLogoWhite,
  mail: Mail,
  masterCard: MasterCard,
  measuringTape: MeasuringTape,
  minus: Minus,
  myAccountLoginLogo: MyAccountLoginLogo,
  nextCard: NextCard,
  nextSlash: NextSlash,
  creditCard: CreditCard,
  noticeIcon: NoticeIcon,
  onlineOrder: OnlineOrder,
  overview: Overview,
  paypal: PayPal,
  payBill: PayBill,
  personalInfoIcon: PersonalInfoIcon,
  phone: PhoneIcon,
  pinPad: PinPad,
  pinterest: Pinterest,
  pipe: Pipe,
  plus: Plus,
  present: Present,
  receiptlessReturns: ReceiptlessReturns,
  redStripe: RedStripe,
  rewards: Rewards,
  rewardsEmptyWhite: RewardsEmptyWhite,
  rewardStarDark: RewardStarDark,
  rewardStarLight: RewardStarLight,
  seller: SellerIcon,
  shipToHome: ShipToHome,
  shippingTruck: ShippingTruck,
  searchIcon: SearchIcon,
  shoppingBag: ShoppingBag,
  styleEditorLogo: StyleEditorLogo,
  toolTipIcon: ToolTipIcon,
  twitter: Twitter,
  visa: Visa,
  warningYellow: WarningYellow,
  x: X,
  youtube: YouTube,
};

export type IconV1IconNames = keyof typeof svgs;
export type ImageIconNames =
  | 'chatBubble'
  | 'downArrow'
  | 'mapArrow'
  | 'pin'
  | 'upArrow';

export interface IconV1Props {
  className?: string;
  fill?: string;
  height?: string;
  icon: IconV1IconNames | ImageIconNames;
  width?: string;
}

export type IconSvgComponents = Record<
  IconV1IconNames,
  React.ComponentType<IconV1Props>
>;

export const imageIcons = [
  'chatBubble',
  'downArrow',
  'mapArrow',
  'pin',
  'upArrow',
];
/**
 * This component is a legacy component for rendering icons.  Try and use IconV2 instead.
 * This component primarily renders svg icons. But then we updated it to also render some image
 * icons. This update should never have happened.  Image-based icons should have been moved to their
 * own component.
 */
function Icon({
  icon,
  backgroundCircleClass,
  backgroundCircleFill,
  hasBackgroundCircle,
}: IconsProps) {
  // if we find an image icon, display it and exit
  if (imageIcons.indexOf(icon) !== -1) {
    return (
      <span role="presentation" className={s[`icon${capitalize(icon)}`]} />
    );
  }

  // we can use "as" here because if we encountered an image, we've already exited this component
  // see the if block directly above.
  const SVG = svgs[icon as IconV1IconNames];
  if (SVG) {
    if (hasBackgroundCircle) {
      return (
        <span className={cn(s.backgroundContainer, backgroundCircleClass)}>
          <Circle icon="circle" fill={backgroundCircleFill} />
          <SVG icon={icon} />
        </span>
      );
    }

    return <SVG icon={icon} />;
  }

  // impossible to get here if using typescript, because you must pick a valid icon
  // or image icon. Only someone using vanilla javascript could possibly accidentally
  // get here.
  /* istanbul ignore next */
  return null;
}

export default Icon;
